import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-mobility-solutions',
  templateUrl: './mobility-solutions.component.html',
  styleUrls: ['./mobility-solutions.component.scss'],
})
export class MobilitySolutionsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
